import { render, staticRenderFns } from "./Csp4Board.vue?vue&type=template&id=da4de9f6&scoped=true&lang=pug"
import script from "./Csp4Board.vue?vue&type=script&lang=js"
export * from "./Csp4Board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4de9f6",
  null
  
)

export default component.exports